import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Almaty.png'
import _imports_1 from '@/assets/images/almaty1.jpg'
import _imports_2 from '@/assets/images/almaty2.jpg'
import _imports_3 from '@/assets/images/almaty3.jpg'
import _imports_4 from '@/assets/images/almaty4.jpg'
import _imports_5 from '@/assets/images/almaty5.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Достопримечательности Алматы"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Алматы – уникальный город: по-восточному шумный и по-европейски элегантный, обаятельный в любое время года. Туристы могут совершать прогулку по этому современному мегаполису, а уже через 30 минут езды от его центра – наблюдать красоты природы или отдыхать на горнолыжном курорте. Как утверждает многолетняя статистика туризма, Алматы привлекает туристов идеальным сочетанием разных типов отдыха ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, " Чем Алматы интересен для путешественников ")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " У Алматы немало достоинств с точки зрения привлекательного для путешественников города. Здесь комфортно в любой сезон года: зимой нет суровых морозов, летом практически не бывает изнуряющей жары, а ночами с гор спускается приятная прохлада. Это привлекает туристов из Европы, которые ценят максимальный комфорт во время поездки. Статистика по туризму утверждает, что немало иностранцев в последние годы приезжает в Алматы ради горнолыжного курорта, находящегося всего в получасе езды от центра мегаполиса. Но столь же часто целью их путешествия становится сам город. ")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Кто Приезжает В Алматы")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Год назад город посетило немало туристов из-за рубежа. Если ранее в страну приезжали путешественники преимущественно из Франции, Германии, Голландии, Англии, США, то в последнее время наблюдается интерес к Казахстану у туристов из стран Восточной Европы. Это объяснимо: авиакомпании открыли прямые рейсы в страну из Венгрии, Польши, Чехии, Словакии, Словении. Среди путешественников преобладали молодые люди 20-35 лет, представители совершенно разных профессий, и приезжали обычно на 1-2 недели. Город привлекает не только иностранцев, но и жителей страны, которых интересует внутренний туризм, – статистика подтверждает, что Алматы год от года посещает все больше казахстанцев из других регионов страны. Такие путешественники не гостят в городе долго, предпочитая «туризм выходного дня». ")
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "20669")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "29,2")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "898531")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "435699")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Как развивается туризм в Алматы? Каждый год в городе открываются новые и модернизируются существующие туристические объекты: гостиницы, включая домашние мини-отели, рестораны, а также другие места, привлекающие посетителей: от современных ночных клубов и бильярдных до кальянных и кафе с восточной кухней. Пару лет назад главной проблемой, с которой сталкивались иностранцы в Казахстане, был низкий уровень владения английским языком принимающей стороны, однако сегодня ситуация значительно улучшилась. Неудобством можно было назвать и отсутствие еще несколько лет назад регулярного транспортного сообщения в будние дни от Алматы до популярных туристических объектов в «низкий сезон» Сегодня из Алматы в любое популярное у путешественников место можно без проблем добраться практически в любой день года. ")
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}